module.exports = __webpack_public_path__ + "static/img/Jeremy_Howe_desktop.a8728f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy_Howe_desktop.jpg
// module id = Nc9o
// module chunks = 0